import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, X, ChevronLeft, ChevronRight } from "lucide-react";

const locationImages = [
  "https://static.wixstatic.com/media/3a96ea_fca391fe27da426aa7347d128dd1494c~mv2.jpg/v1/fill/w_600,h_776,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Note%20about%20Locations.jpg",
  "https://static.wixstatic.com/media/3a96ea_80b17b4b91f341b0850e38fb0ecb997a~mv2.jpg/v1/fill/w_600,h_776,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Location%2011.jpg",
  "https://static.wixstatic.com/media/3a96ea_d0d442598ef54abda9e317bcc6b21255~mv2.jpg/v1/fill/w_600,h_776,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Location%207.jpg",
  "https://static.wixstatic.com/media/3a96ea_d7fc613a248e4eea8f0f9e4c3acfb4f4~mv2.jpg/v1/fill/w_606,h_784,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/3a96ea_d7fc613a248e4eea8f0f9e4c3acfb4f4~mv2.jpg",
  "https://static.wixstatic.com/media/3a96ea_08067221e6a343939d6d0703b939a887~mv2.jpg/v1/fill/w_580,h_752,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/3a96ea_08067221e6a343939d6d0703b939a887~mv2.jpg",
  "https://static.wixstatic.com/media/3a96ea_79ab5f9beac1417781ff46c690bcb72e~mv2.jpg/v1/fill/w_574,h_744,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/3a96ea_79ab5f9beac1417781ff46c690bcb72e~mv2.jpg",
  "https://static.wixstatic.com/media/3a96ea_4de84b16ef56434fa486b2f4a607c302~mv2.jpg/v1/fill/w_549,h_712,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/3a96ea_4de84b16ef56434fa486b2f4a607c302~mv2.jpg",
  "https://static.wixstatic.com/media/3a96ea_78bc02408b984a6ca3f94aac8dd92790~mv2.jpg/v1/fill/w_549,h_712,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/3a96ea_78bc02408b984a6ca3f94aac8dd92790~mv2.jpg",
  "https://static.wixstatic.com/media/3a96ea_809e554426bf4fa2bbf1311803893ac7~mv2.jpg/v1/fill/w_533,h_690,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/3a96ea_809e554426bf4fa2bbf1311803893ac7~mv2.jpg",
  "https://static.wixstatic.com/media/3a96ea_b3e4a2ebd39047ad84379f47d1b0384f~mv2.jpg/v1/fill/w_533,h_690,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/3a96ea_b3e4a2ebd39047ad84379f47d1b0384f~mv2.jpg",
  "https://static.wixstatic.com/media/3a96ea_558bc397d03e42ff90a19185dd1eea69~mv2.jpg/v1/fill/w_521,h_672,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Appleway%20copy.jpg",
  "https://static.wixstatic.com/media/3a96ea_e2b8a9ae8a154fa0b597e99e91d3e0c7~mv2.jpg/v1/fill/w_514,h_665,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Location%206%20copy.jpg",
  "https://static.wixstatic.com/media/3a96ea_dc325a32839241119aaad84546b77f56~mv2.jpg/v1/fill/w_508,h_658,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/3a96ea_dc325a32839241119aaad84546b77f56~mv2.jpg",
  "https://static.wixstatic.com/media/3a96ea_d37568cf2e9e4db7b14155b6b4f39d75~mv2.jpg/v1/fill/w_483,h_626,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/3a96ea_d37568cf2e9e4db7b14155b6b4f39d75~mv2.jpg",
  "https://static.wixstatic.com/media/3a96ea_49ab8829a2204758a23b9ef909d69982~mv2.jpg/v1/fill/w_463,h_600,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/3a96ea_49ab8829a2204758a23b9ef909d69982~mv2.jpg",
  "https://static.wixstatic.com/media/3a96ea_6f8b360a20dd46049a85f6f7b4fd0742~mv2.jpg/v1/fill/w_463,h_600,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/3a96ea_6f8b360a20dd46049a85f6f7b4fd0742~mv2.jpg",
  "https://static.wixstatic.com/media/3a96ea_a1a9a01dacb647b393ac05591cffef68~mv2.jpg/v1/fill/w_469,h_608,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/3a96ea_a1a9a01dacb647b393ac05591cffef68~mv2.jpg",
  "https://static.wixstatic.com/media/3a96ea_c6002f5110da4ba0ab3ddfad0d7936b2~mv2.jpg/v1/fill/w_463,h_600,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/3a96ea_c6002f5110da4ba0ab3ddfad0d7936b2~mv2.jpg",
  "https://static.wixstatic.com/media/3a96ea_87154f728c714546995c3f8190bec6e7~mv2.jpg/v1/fill/w_463,h_600,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/3a96ea_87154f728c714546995c3f8190bec6e7~mv2.jpg",
];

const LocationsPage = () => {
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const closeLightbox = useCallback(() => setLightboxIndex(null), []);
  const goNext = useCallback(() =>
    setLightboxIndex((i) => (i + 1) % locationImages.length), []);
  const goPrev = useCallback(() =>
    setLightboxIndex((i) => (i - 1 + locationImages.length) % locationImages.length), []);

  useEffect(() => {
    if (lightboxIndex === null) return;
    const handleKey = (e) => {
      if (e.key === "Escape") closeLightbox();
      if (e.key === "ArrowRight") goNext();
      if (e.key === "ArrowLeft") goPrev();
    };
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", handleKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", handleKey);
    };
  }, [lightboxIndex, closeLightbox, goNext, goPrev]);

  return (
    <div className="min-h-screen bg-[#FDFBF9]" data-testid="locations-page">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 glass-header border-b border-[#E8E4DD]">
        <nav className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex items-center justify-between h-20">
            <Link
              to="/"
              className="flex items-center gap-2 font-body text-sm text-[#5C5A56] hover:text-[#2C2A28] transition-colors"
              data-testid="back-to-home"
            >
              <ArrowLeft size={18} />
              Back to Home
            </Link>
            <span className="font-heading text-xl text-[#2C2A28]">
              Brittany Bailey Photography
            </span>
            <div className="w-24" />
          </div>
        </nav>
      </header>

      {/* Main Content */}
      <main className="pt-32 pb-20 px-6 lg:px-12">
        <div className="max-w-6xl mx-auto">
          {/* Title */}
          <div className="text-center mb-16">
            <p className="overline text-[#C8A99C] mb-4">Session Inspiration</p>
            <h1 className="font-heading text-4xl lg:text-6xl font-light tracking-tight text-[#2C2A28] mb-6">
              Locations
            </h1>
            <div className="section-divider mx-auto mb-6" />
            <p className="font-body text-[#5C5A56] max-w-2xl mx-auto">
              Explore some of the beautiful locations available for your photography session in the Breaux Bridge and Lafayette area.
            </p>
          </div>

          {/* Image Grid - Masonry Style */}
          <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 space-y-4">
            {locationImages.map((image, index) => (
              <div
                key={index}
                className="break-inside-avoid overflow-hidden group cursor-pointer"
                data-testid={`location-image-${index}`}
                onClick={() => setLightboxIndex(index)}
              >
                <img
                  src={image}
                  alt={`Location ${index + 1}`}
                  className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="text-center mt-16">
            <p className="font-body text-[#5C5A56] mb-6">
              Have a location in mind? Let's make it happen!
            </p>
            <Link
              to="/#contact"
              className="inline-block px-8 py-4 bg-[#2C2A28] text-[#FDFBF9] font-body text-sm tracking-wide hover:bg-[#5C5A56] transition-colors"
              data-testid="locations-contact-btn"
            >
              Contact Me
            </Link>
          </div>
        </div>
      </main>

      {/* Lightbox */}
      {lightboxIndex !== null && (
        <div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 animate-in fade-in duration-200"
          data-testid="lightbox-overlay"
          onClick={closeLightbox}
        >
          {/* Close */}
          <button
            className="absolute top-6 right-6 text-white/70 hover:text-white transition-colors"
            data-testid="lightbox-close"
            onClick={closeLightbox}
          >
            <X size={28} />
          </button>

          {/* Counter */}
          <span className="absolute top-6 left-6 font-body text-sm text-white/50">
            {lightboxIndex + 1} / {locationImages.length}
          </span>

          {/* Prev */}
          <button
            className="absolute left-4 md:left-8 text-white/50 hover:text-white transition-colors"
            data-testid="lightbox-prev"
            onClick={(e) => { e.stopPropagation(); goPrev(); }}
          >
            <ChevronLeft size={36} />
          </button>

          {/* Image */}
          <img
            src={locationImages[lightboxIndex]}
            alt={`Location ${lightboxIndex + 1}`}
            className="max-h-[85vh] max-w-[90vw] object-contain select-none"
            data-testid="lightbox-image"
            onClick={(e) => e.stopPropagation()}
          />

          {/* Next */}
          <button
            className="absolute right-4 md:right-8 text-white/50 hover:text-white transition-colors"
            data-testid="lightbox-next"
            onClick={(e) => { e.stopPropagation(); goNext(); }}
          >
            <ChevronRight size={36} />
          </button>
        </div>
      )}

      {/* Footer */}
      <footer className="bg-[#2C2A28] text-[#FDFBF9] py-8">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 text-center">
          <p className="font-body text-sm text-[#A8B5A3]">
            &copy; {new Date().getFullYear()} Brittany Bailey Photography. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default LocationsPage;
